import {createAction, props} from "@ngrx/store";
import {ClientDetails} from "../../../../models/client-details";
import {AddClientDetailsModel} from "../models/add-client-details.model";
import {UpdateClientDetailsModel} from "../models/update-client-details.model";
import {FetchClientDetailsModel} from "../models/fetch-client-details.model";
import {Filter} from "../../../../models/filter";

/******** CLEAR STATE ***********/

const CLEAR_STATE = '[client details] clear state';
export const ClearState = createAction(CLEAR_STATE);

/*********** FETCH CLIENT DETAILS **************/

const FETCH_CLIENT_DETAILS_REQUEST = '[client details] fetch client details requested';
export const FetchClientDetailsRequest = createAction(FETCH_CLIENT_DETAILS_REQUEST, props<{
  payload: FetchClientDetailsModel['request']
}>());
const FETCH_CLIENT_DETAILS_SUCCESS = '[client details] fetch client details successful';
export const FetchClientDetailsSuccess = createAction(FETCH_CLIENT_DETAILS_SUCCESS, props<{
  clientDetails: ClientDetails,
  message: string
}>());
const FETCH_CLIENT_DETAILS_FAILURE = '[client details] fetch client details failure';
export const FetchClientDetailsFailure = createAction(FETCH_CLIENT_DETAILS_FAILURE);

/*********** ADD CLIENT DETAILS **************/

const ADD_CLIENT_DETAILS_REQUEST = '[client details] add client details requested';
export const AddClientDetailsRequest = createAction(ADD_CLIENT_DETAILS_REQUEST, props<{
  payload: AddClientDetailsModel['request']
}>());
const ADD_CLIENT_DETAILS_SUCCESS = '[client details] add client details successful';
export const AddClientDetailsSuccess = createAction(ADD_CLIENT_DETAILS_SUCCESS, props<{
  clientDetails: ClientDetails,
  allowInvite: boolean,
  message: string
}>());
const ADD_CLIENT_DETAILS_FAILURE = '[client details] add client details failure';
export const AddClientDetailsFailure = createAction(ADD_CLIENT_DETAILS_FAILURE);

/*********** UPDATE CLIENT DETAILS **************/

const UPDATE_CLIENT_DETAILS_REQUEST = '[client details] update client details requested';
export const UpdateClientDetailsRequest = createAction(UPDATE_CLIENT_DETAILS_REQUEST, props<{
  payload: UpdateClientDetailsModel['request']
}>());
const UPDATE_CLIENT_DETAILS_SUCCESS = '[client details] update client details successful';
export const UpdateClientDetailsSuccess = createAction(UPDATE_CLIENT_DETAILS_SUCCESS, props<{
  clientDetails: ClientDetails,
  message: string
}>());
const UPDATE_CLIENT_DETAILS_FAILURE = '[client details] update client details failure';
export const UpdateClientDetailsFailure = createAction(UPDATE_CLIENT_DETAILS_FAILURE);

/*********** FETCH CLIENT STATUS FILTER **************/

const FETCH_CLIENT_STATUS_FILTER_REQUEST = '[client details] fetch client status filter requested';
export const FetchClientStatusFilterRequest = createAction(FETCH_CLIENT_STATUS_FILTER_REQUEST);
const FETCH_CLIENT_STATUS_FILTER_SUCCESS = '[client details] fetch client status filter successful';
export const FetchClientStatusFilterSuccess = createAction(FETCH_CLIENT_STATUS_FILTER_SUCCESS, props<{
  clientStatusFilter: Filter,
  message: string
}>());
const FETCH_CLIENT_STATUS_FILTER_FAILURE = '[client details] fetch client status filter failure';
export const FetchClientStatusFilterFailure = createAction(FETCH_CLIENT_STATUS_FILTER_FAILURE);

/*********** FETCH ORG TYPE LIST **************/

const FETCH_ORGANIZATION_TYPE_FILTER_REQUEST = '[client details] fetch organization type filter requested';
export const FetchOrganizationTypeFilterRequest = createAction(FETCH_ORGANIZATION_TYPE_FILTER_REQUEST);
const FETCH_ORGANIZATION_TYPE_FILTER_SUCCESS = '[client details] fetch organization type filter successful';
export const FetchOrganizationTypeFilterSuccess = createAction(FETCH_ORGANIZATION_TYPE_FILTER_SUCCESS, props<{
  organizationTypeFilter: Filter,
  message: string
}>());
const FETCH_ORGANIZATION_TYPE_FILTER_FAILURE = '[client details] fetch organization type filter failure';
export const FetchOrganizationTypeFilterFailure = createAction(FETCH_ORGANIZATION_TYPE_FILTER_FAILURE);

/*********** FETCH CLIENT NAME **************/
const FETCH_CLIENT_NAME_REQUEST = '[client details] fetch client name requested';
export const FetchClientNameRequest = createAction(FETCH_CLIENT_NAME_REQUEST, props<{
  payload: FetchClientDetailsModel['request']
}>());

const FETCH_CLIENT_NAME_SUCCESS = '[client details] fetch client name successful';
export const FetchClientNameSuccess = createAction(FETCH_CLIENT_NAME_SUCCESS, props<{
  name: string,
  message: string
}>());

const FETCH_CLIENT_NAME_FAILURE = '[client details] fetch client name failure';
export const FetchClientNameFailure = createAction(FETCH_CLIENT_NAME_FAILURE);

/*********** DELETE CLIENT **************/
const DELETE_CLIENT_REQUEST = '[client details] delete client name' +
                                   ' requested';
export const DeleteClientRequest = createAction(DELETE_CLIENT_REQUEST, props<any>());

const DELETE_CLIENT_SUCCESS = '[client details] delete client successful';
export const DeleteClientSuccess = createAction(DELETE_CLIENT_SUCCESS, props<{
  message: string
}>());

const DELETE_CLIENT_FAILURE = '[client details] delete client failure';
export const DeleteClientFailure = createAction(DELETE_CLIENT_FAILURE);
